import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Handshake, HeartHandshake } from "lucide-react";

const STATUS_COLOR = {
  "Being reviewed": "#B7791F", "Referred": "#1C4358", "Appointment pending": "#B7791F",
  "Tour pending": "#B7791F", "Estimate pending": "#B7791F", "In progress": "#1C4358",
  "Waiting on partner": "#B7791F", "Follow-up needed": "#9C1E22", "Completed": "#2F7D5A", "Closed": "#9AA5B1",
};

export default function ClientReferrals() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/portal/client/referrals").then(({ data }) => setItems(data.items)).catch(() => setItems([])); }, []);

  if (items === null) return <div className="space-y-3"><Skeleton className="h-20" /><Skeleton className="h-20" /></div>;

  return (
    <div data-testid="client-referrals-page">
      <h2 className="font-display text-2xl font-bold text-[#252221] flex items-center gap-2"><Handshake size={22} /> Your referrals</h2>
      <p className="text-[15px] text-muted-foreground mb-5">Trusted partners your guide has connected you with, and where things stand.</p>
      {items.length === 0 ? (
        <Card className="p-10 text-center border-[#E6EDF2]" data-testid="client-referrals-empty">
          <HeartHandshake size={40} className="mx-auto text-[#1C4358]/40 mb-3" />
          <div className="font-display font-semibold text-[18px] text-[#252221]">No referrals yet</div>
          <p className="text-[15px] text-muted-foreground mt-1">If your guide connects you with a trusted partner, you'll see the details and status here.</p>
        </Card>
      ) : (
        <div className="space-y-3">
          {items.map((r) => (
            <Card key={r.id} className="p-4 border-[#E6EDF2] flex items-center gap-3" data-testid={`client-referral-${r.id}`}>
              <span className="h-10 w-10 rounded-xl bg-[#1C4358]/8 text-[#1C4358] flex items-center justify-center shrink-0"><Handshake size={19} /></span>
              <div className="min-w-0 flex-1">
                <div className="text-[15px] font-medium text-[#252221]">{r.partner_name}</div>
                {r.referral_type && <div className="text-[13px] text-muted-foreground capitalize">{String(r.referral_type).replace(/[-_]/g, " ")}</div>}
                {r.note && <div className="text-[13px] text-[#4B5563] mt-1">{r.note}</div>}
              </div>
              <span className="text-[13px] font-semibold px-3 py-1 rounded-full shrink-0" style={{ background: (STATUS_COLOR[r.status] || "#9AA5B1") + "1a", color: STATUS_COLOR[r.status] || "#9AA5B1" }} data-testid={`client-referral-status-${r.id}`}>{r.status}</span>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
